import { render, staticRenderFns } from "./DecoEntryForVote.vue?vue&type=template&id=59bad914&"
import script from "./DecoEntryForVote.vue?vue&type=script&lang=ts&"
export * from "./DecoEntryForVote.vue?vue&type=script&lang=ts&"
import style0 from "./DecoEntryForVote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports